export const route = {
    name: 'Route',
    description: '',
    displayField: 'path',
    fields: {
        path: {
            name: 'Path',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        linkTitle: {
            name: 'Link title',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        linkImage: {
            name: 'Link image',
            type: 'Link',
            linkType: 'Asset',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [{ linkMimetypeGroup: ['image'] }]
        }
    }
};
//# sourceMappingURL=route.js.map